// Contenus de démonstration (avis, équipe, chiffres) : à remplacer par les vrais.

export const PROOFS = [
    {
        figure: '0\u00A0€',
        title: 'Le diagnostic',
        text: 'Offert pour toute réparation faite à l’atelier. Voyant allumé, bruit suspect : on cherche gratuitement.'
    },
    {
        figure: '100\u00A0%',
        title: 'De devis écrits',
        text: 'Remis avant travaux. Rien n’est ajouté à la facture sans votre accord signé.'
    },
    {
        figure: '2\u00A0ans',
        title: 'De garantie',
        text: 'Pièces d’origine ou de qualité équivalente, main-d’œuvre comprise. Garantie constructeur préservée.'
    },
    {
        figure: '96\u00A0%',
        title: 'Rendues à l’heure',
        text: 'Des voitures restituées le jour et à l’heure annoncés en 2025, sur 2 140 interventions.'
    }
]

export const REVIEWS = [
    {
        author: 'Claire M.',
        vehicle: 'Peugeot 3008 BlueHDi, 2018',
        service: 'Distribution',
        timing: 'Rendue le jour même',
        date: 'Septembre 2026',
        text: 'Un devis à 1 150 € en concession pour la distribution. Ici 689 €, exactement le prix annoncé au téléphone, et la voiture prête à 17 h comme promis. Erwan m’a même montré l’ancienne courroie.'
    },
    {
        author: 'Julien R.',
        vehicle: 'Renault Clio IV, 2016',
        service: 'Diagnostic et capteur',
        timing: 'Pris en charge en 1 h',
        date: 'Août 2026',
        text: 'Voyant moteur allumé un lundi matin. Pris en charge à 9 h, diagnostic offert, capteur changé avant midi. Rien à redire.'
    },
    {
        author: 'Nadia B.',
        vehicle: 'Volkswagen Golf 7, 2015',
        service: 'Freinage',
        timing: 'Rendue en 2 h',
        date: 'Septembre 2026',
        text: 'Ils m’ont envoyé une photo des disques avant de toucher à quoi que ce soit. Je n’avais jamais vu ça dans un garage.'
    },
    {
        author: 'Thomas L.',
        vehicle: 'Toyota C-HR hybride, 2021',
        service: 'Révision',
        timing: 'Rendue en 1 h 30',
        date: 'Juillet 2026',
        text: 'Révision faite selon le carnet, tampon compris : ma garantie constructeur est préservée et j’ai payé bien moins qu’en concession.'
    },
    {
        author: 'Mathieu G.',
        vehicle: 'Renault Kangoo, 2019',
        service: 'Disques et plaquettes',
        timing: 'Rendu sous 24 h',
        date: 'Juin 2026',
        text: 'Utilitaire immobilisé, c’est du chiffre d’affaires perdu. Rendez-vous le lendemain à 8 h, Kangoo rendu à 15 h. Ils ont compris.'
    }
]

export const RATING_BREAKDOWN = [
    { stars: 5, share: 94 },
    { stars: 4, share: 5 },
    { stars: 3, share: 1 },
    { stars: 2, share: 0 },
    { stars: 1, share: 0 }
]

export const TEAM = [
    {
        name: 'Gwenaëlle Le Bris',
        role: 'Accueil, devis et planning',
        detail: 'C’est elle qui décroche, établit votre devis et tient les délais.'
    },
    {
        name: 'Kévin Moreau',
        role: 'Mécanicien, diagnostic électronique',
        detail: 'Habilité véhicules hybrides et électriques, 12 ans de métier.'
    },
    {
        name: 'Lucas Prigent',
        role: 'Mécanicien, freinage et liaisons au sol',
        detail: 'Géométrie, amortisseurs, pneus : le confort de conduite, c’est lui.'
    },
    {
        name: 'Malo Riou',
        role: 'Apprenti, BTS maintenance des véhicules',
        detail: 'Formé à l’atelier, deuxième année, déjà redoutable sur les révisions.'
    }
]

export const FOUNDER_STATS = [
    { figure: '28\u00A0ans', label: 'de métier' },
    { figure: '15\u00A0ans', label: 'sur l’île de Nantes' },
    { figure: '9\u202F400', label: 'véhicules suivis' }
]

export const EQUIPMENT = [
    { figure: '4\u00A0ponts', label: 'élévateurs, dont un dédié aux utilitaires' },
    { figure: '380\u00A0m²', label: 'd’atelier chauffé, nettoyé chaque soir' },
    { figure: 'Géométrie 3D', label: 'parallélisme réglé au dixième de degré' },
    { figure: 'Multimarque', label: 'valise de diagnostic mise à jour chaque mois' },
    { figure: 'Clim 2\u00A0gaz', label: 'recharge R134a et R1234yf, contrôle d’étanchéité' },
    { figure: '0\u00A0rayure', label: 'démonte-pneus sans levier, jantes alu protégées' }
]

export const PRACTICAL_INFOS = [
    { icon: 'parking', title: 'Parking client', text: '8 places devant l’atelier, gratuites.' },
    { icon: 'key', title: 'Boîte à clés 24 h/24', text: 'Déposez votre voiture la veille au soir, on s’occupe du reste.' },
    { icon: 'car', title: 'Véhicule de prêt', text: 'Sur réservation, pour les interventions de plus d’une journée.' },
    { icon: 'card', title: 'Paiement', text: 'Carte bancaire, espèces, virement. Facture détaillée par email.' }
] as const
